export default (props = {}, fallback) => {
  if (!Object.keys(props).length) {
    return fallback
  }

  return props.id || props.href || props.to || props.name || fallback
}
